import { createBlock } from 'factories/block';
import { repeat } from './interaction';
import { createLayout } from 'factories/layout';
import { colors } from 'styles/variables';
import { createMediaBlock } from './media';
import { Block, cloneBlock, Blocks } from '@chameleoncreator/creator-app';
import { flatten } from 'factories/utils';
import { createContinueBtn } from './continueBtn';
import { createEditableBtn } from './editableBtn';
import { getSId } from '../utils';

const { lGrey0, lGrey2 } = colors;

const createClickAndRevealBlock = props => {
  return createBlock('ClickAndReveal', [
    createMediaBlock({
      src: undefined,
      child: 1,
      fit: 'cover',
      useBackgroundControls: false,
    }),
    createBlock('Text', [], { props: { useBackgroundControls: false } }),
    createBlock('Content', [
      createMediaBlock({ name: 'ColumnRowA', child: 0 }),
      createMediaBlock({ name: 'ColumnRowB', child: 1 }),
      createEditableBtn({
        type: 'ClickAndRevealContentButton',
        label: 'Continue',
      }),
    ]),
  ]);
};

export const createClickAndRevealsBlock = (count: number) => {
  return createBlock('ClickAndReveals', [
    ...repeat(() => createClickAndRevealBlock({}), count),
  ]);
};

export const addClickAndReveal = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'ClickAndReveals') {
    const clickAndRevealBlock = createClickAndRevealBlock({});

    const clickAndRevealBlockRef = { id: clickAndRevealBlock.id, type: 'Ref' };
    const [newBlocks] = flatten(clickAndRevealBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 0, clickAndRevealBlockRef);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const removeClickAndReveal = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'ClickAndReveals') {
    const clickAndRevealBlock = createClickAndRevealBlock({});

    const [newBlocks] = flatten(clickAndRevealBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 1);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

const contentForColumn = (count: number) => (i: number) => {
  return [
    () => createBlock('Text', [], { props: { useBackgroundControls: true } }),
    () => createClickAndRevealsBlock(count),
  ][i];
};

export const createClickAndRevealInteractionBlock = props => {
  const {
    backgroundColor,
    clickAndRevealPanelTextColor = lGrey0,
    clickAndRevealLabelTextColor = lGrey0,
    width = 260,
    height = 210,
    borderRadius = 10,
    borderColor = lGrey2,
    layout = 'One column reversed',
    lockDown = 0,
    style,
  } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(contentForColumn(props.answerCount), 0, true),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
        backgroundColor,
        clickAndRevealPanelTextColor,
        clickAndRevealLabelTextColor,
        borderRadius,
        borderColor,
        width,
        height,
        layout,
        lockDown,
      },
      meta: {
        subType: 'ClickAndReveal',
        layout: 'OneColumn',
      },
    }
  );
};

export const create = createClickAndRevealInteractionBlock;
export const interactionConfig = {};
